<template>
  <div style="background: #fff">
    <div class="dianzan-box">
      <i :class="{ active: dianzanState }">+1</i>
      <img src="../assets/img/dianzhan.png" alt="" @click="dianzan" />
    </div>
    <div class="csTop" id="pageTop">
      <div class="bxBox">
        <div class="Logo">
          <img src="../assets/img/flogo.png" alt="" />
        </div>
        <div class="topRight">
          <div class="Phone">服务热线：010-88810708</div>
          <a class="Fanh" href="http://demo.csz.emof.cn/web/"
            ><img src="../assets/Template/fanhui.png" alt="" />返回公益汇</a
          >
          <!--          <div class="tuichu"><img src="../assets/Template/tuichu.png" alt="">退出</div>-->
        </div>
      </div>
    </div>

    <div class="csNav">
      <div class="bx-Box">
        <div class="navLeft">
          <div>
            <img src="../assets/Template/Logo.png" alt="" />
          </div>
          <p style="flex: 1; line-height: 120%">社会组织孵化基地北部基地</p>
        </div>
      </div>
    </div>

    <div class="csBanner" id="pageInfo">
      <div class="BannerLeft">
        <img src="http://gyhfile.shzzfw.com/bb0.jpg" alt="" />
      </div>
      <div class="Bannerright">
        <div>
          <p style="text-indent: 32px">
            北京市昌平区社会组织发展服务中心于2018年5月正式注册成立，承接昌平区社会组织孵化基地运维项目并正式对外开放，9月被确立为“北京市社会组织孵化中心北部基地”，2019年3月启动回天社会创新学院，并为入驻的85家机构提供孵化服务，截止2020年9月30日，共孵化社会组织112家。2019年4月，北京市回天社区公益基金会成立，初始资金200万元，目前整体投资近800万元，2019年10月，回天政府采购平台上线，吸引和带动众多社会组织来到回天地区参与社会服务实践。
          </p>
          <div class="BannerBox">
            <div class="bannerBtn2" @click="telVisible = true">
              <img src="../assets/Template/yijiantonghua.png" alt="" />一键通话
            </div>
            <div class="bannerBtn3" @click="codeVisible = true">
              <img src="../assets/Template/yijianzhuanfa.png" alt="" />一键转发
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="csBottom">
      <div class="bx">
        <div class="fcTit">基地风采</div>

        <div class="fc-desc">
          <h3>一、区、街镇、社区三级孵化</h3>
          <p>
            为了探索和实践中国超大型城市基层社会创新，提升社区治理的水平，输出优质的社会服务，营造美好社区，我们在党建引领下尝试打造一个区级、镇街级和社区级相互联动的一个孵化平台，为此，我们提供人才孵化、组织孵化、服务孵化、机制孵化方面的服务和产品包。
          </p>
          <p>
            2020年10月27日下午，为助力各镇街社区社会组织依托联合会承接政府购买社会组织服务，提升社区社会组织进行项目化方式开展活动的能力，昌平区社会组织发展服务中心于开展了“镇街社区社会组织承接政府购买社会组织服务沟通说明会”，来自各镇街社区社会组织联合会负责人及财务工作人员约20人参与了此次活动。
          </p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/bb1.jpg" alt="" />
            <p>昌平-区街镇社区三级孵化</p>
          </div>
        </div>

        <div class="fc-desc">
          <h3>二、三位一体孵化体系</h3>
          <p>
            本中心的孵化职能由三大体系支撑，分别是社会组织孵化基地、回天社会创新学院、回天社会服务设计创新中心，其中，社会组织孵化基地为入孵机构提供办公空间和共享活动空间，创新学院为社会组织、社会企业提供组织孵化服务，为社区社工、志愿者提供人才孵化服务，社会服务设计创新中心为社会组织提供服务孵化和机制孵化。
          </p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/bb2.png" alt="" />
            <p>昌平-三位一体孵化体系</p>
          </div>
        </div>

        <div class="fc-desc">
          <h3>三、回天社会创新学院</h3>
          <p>
            2019年3月，回天社会创新学院正式启动，为社会组织、社会企业、志愿者、社会工作者提供能力支持，2020年，新增了回天环保学院和回天物业管理创新学院，回应目前基层社会治理当中面对的两个突出问题。
          </p>
          <p>
            2019年8月的回天地区基层治理能力提升培训班，面向昌平区基层社区工作者，以参与式学习的组织方式，开展“如何设计和落实社区服务项目”、“社区议事协商过程中的主持人技术”、“社区志愿者动员与管理”、“如何培育社区自组织”等内容，为基层社区工作者带去好理解、可运用的能力提升服务。
          </p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/bb3.jpg" alt="" />
            <p>昌平-回天社会创新学院</p>
          </div>
        </div>

        <div class="fc-desc">
          <h3>四、回天社会服务设计创新中心</h3>
          <p>
            打造回天社会服务设计创新中心，培养多元社会创新力量,依托回天人才资源，创建回天社会服务设计创新中心，打造资源与智慧共享的众创平台。服务对象涵盖新一代互联网等科技人才、小创业人群、全职妈妈、独立职业人员等多元社会力量，孵化产业包括物业创新、社区环保、社区养老、社区文化、社区环境与秩序、社区商业、社区公益、社区党建等社会服务产业。
          </p>
          <p>
            针对回天地区社会经济发展需求进行分析梳理，建立专项问题解决实验室，以项目为导向，实现一对一导师辅导及项目孵化，为不同培养对象提供有效的针对性的问题解决方案。通过项目设计工作坊打磨符合回天地区特色的项目解决方案并进行落地试点、推广服务，运用科技手段提升社区公共服务。
          </p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/bb4.jpg" alt="" />
          </div>
        </div>

        <div class="fc-desc">
          <h3>五、综合党委</h3>
          <p>
            2020年回天地区社会组织综合党委按照党的十九大对社会组织在协商民主、社会治理、环境治理、基层党组织建设、发展党员等方面都明确的阐明论点并提出要求，结合以上围绕“共建共享、共同发展”的工作原则，以深入开展创先争优活动为载体，紧紧围绕服务中心工作，增强党建工作的有效性。
          </p>
          <p>
            回天地区综合党委成立于2019年7月，我们按照“成熟一个、建立一个、巩固一个、提高一个”的思路，采取“独立式”、“联合式”等模式，因地制宜，灵活设置党组织，加快了新社会党组织的组建步伐。目前共有十个党支部，其中社会组织8个，非公企业1个，联合支部1个，涉及养老、体育、文化、社会服务等多领域。截止2020年8月，共有党员32人，其中流动党员18人。
          </p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/bb5.jpg" alt="" />
            <p>昌平-综合党委</p>
          </div>
          <div>
            <img src="http://gyhfile.shzzfw.com/bb6.jpg" alt="" />
            <p>昌平-综合党委</p>
          </div>
        </div>

        <div class="fc-desc">
          <h3>六、社会企业</h3>
          <p>
            社会企业是社会治理的多元主体之一，昌平区依据《昌平区回天地区社会企业认证与扶持试点办法（试行）》昌社委发〔2019〕12号）的文件要求，挖掘一批具有一定规模、一定影响力和辐射力的社会企业，培养社会企业并促进其在创新社会管理、参与社会治理、改善社会服务等方面发挥积极作用，着力构建共建共治共享的社会治理新格局。本中心为做好回天地区社会企业认证工作，成立回天地区社会企业认证工作组，在区委社会工委的指导下，按照“组织申报、资质初评、尽职调查、信用核查、专家中评、专家终审、审核公示、结果发布”共8项具体流程，开展回天地区社会企业认证工作。
          </p>
          <p>
            回天地区社会企业是指登记注册、税务解缴、统计关系在昌平区，服务区域包含回天地区，以协助解决社会问题、改善社会治理、服务于弱势和特殊群体或社区利益为宗旨，以优先追求社会效益为根本目标，以创新商业模式、市场化运作为主要手段，所得盈利按照其社会目标再投入解决社会问题、创新公共服务供给，且社会目标持续稳定的企业。
          </p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/bb7.png" alt="" />
            <p>昌平-社会企业</p>
          </div>
        </div>
      </div>

      <div class="csLianx" id="pageCall">
        <div class="lianxiTit">
          <img src="../assets/Template/lianxiwomen.png" alt="" />
        </div>
        <div class="bx-Box">
          <div class="lianXLeft">
            <div class="lianXimg">
              <img src="../assets/Template/dianhua.png" alt="" />
            </div>
            <p class="lianXtex">联系电话</p>
            <p class="lianXtex">桂如新 18701220806</p>
          </div>
          <div class="lianXRight">
            <div class="lianXimg">
              <img src="../assets/Template/dizhi.png" alt="" />
            </div>
            <p class="lianXtex">基地地址</p>
            <p class="lianXtex">北京市昌平区回龙观东大街318号首开广场4层</p>
          </div>
        </div>
      </div>
    </div>

    <div class="csFooter">
      <div class="bx-Box">
        <div class="footerLeft">
          <img src="../assets/img/flogo.png" alt="" />
        </div>
        <div class="footerCen">
          <p>主办单位：北京市委社会工委市民政局</p>
          <p>执行单位：北京市社会组织管理中心</p>
          <p>
            协办单位：北京市扶贫协作和支援合作工作领导小组办公室
            中关村科技园区管理委员会
          </p>
          <p>北京市妇女联合会 北京市红十字会 首都公益慈善联合会</p>
          <p>承办单位：北京知诚社会组织众扶发展促进会</p>
          <p>
            All Rights Reserved
            <a href="http://www.beian.gov.cn" style="color: #fff"
              >京ICP备17050284号-4</a
            >
          </p>
        </div>
        <div class="footerRight">
          <div>
            <img src="../assets/Template/ewm.png" alt="" />
            <p>众扶平台公众号</p>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="一键转发"
      :visible.sync="codeVisible"
      width="700px"
      center
    >
      <codemode :url="'bbjd'" />
    </el-dialog>
    <el-dialog title="一键通话" :visible.sync="telVisible" width="700px" center>
      <tel :name="'桂如新 '" :tel="'18701220806'" />
    </el-dialog>
  </div>
</template>

<script>
import codemode from '../components/codemode'
import tel from '../components/tel'
export default {
  name: "shouye",
  components: {
    codemode,
    tel
  },
  data () {
    return {
      dianzanState: false,
      negotiationVisible: false,
      codeVisible: false,
      telVisible: false,
      centerDialogVisible: false,
      showImgIndex: 0,
    }
  },
  created () {
    this.$api.apiContent.dianzan2({
      type: '北部基地',
      t_id: 0,
      op: 1,
    })
  },
  methods: {
    dianzan () {
      this.dianzanState = true
      setTimeout(() => {
        this.dianzanState = false
      }, 600)
      this.$api.apiContent.dianzan2({
        type: '北部基地',
        t_id: 0,
        op: 2,
      })

    },
  }
}
</script>

<style scoped lang="scss">
.dianzan-box {
  z-index: 99;
  position: fixed;
  right: 0;
  top: 70%;
  cursor: pointer;
  i {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 16px;
    color: red;
    opacity: 0;
    transition: all 0.6s linear;
    &.active {
      top: -50px;
      opacity: 1;
      font-size: 36px;
    }
  }
}
.csTop {
  width: 100%;
  height: 80px;
  background: url("../assets/Template/topBGC_01.jpg") no-repeat top center;

  .bxBox {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .Logo {
      display: flex;
      height: 80px;
      justify-content: space-between;
      align-items: center;

      img {
        margin-right: 15px;
      }
    }

    .topRight {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 80px;
      flex: 1;

      .Phone {
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
      }

      .Fanh {
        width: 142px;
        height: 38px;
        background-color: #c70005;
        border-radius: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f0f2f7;
        font-size: 16px;
        cursor: pointer;
        margin-right: 20px;

        img {
          width: 22px;
          margin-right: 10px;
        }
      }

      .tuichu {
        width: 94px;
        height: 38px;
        background-color: #e5580b;
        border-radius: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f0f2f7;
        font-size: 16px;
        cursor: pointer;

        img {
          width: 16px;
          margin-right: 10px;
        }
      }
    }
  }
}

.csNav {
  width: 100%;
  height: 133px;
  background-color: #c70005;

  .navLeft {
    width: 700px;
    display: flex;
    height: 133px;
    justify-content: flex-start;
    align-items: center;
    font-size: 28px;
    font-weight: bold;
    color: #ffffff;

    div {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100px;
      height: 100px;
      border-radius: 100px;
      border: 1px solid #fff100;
      margin-right: 20px;
      overflow: hidden;

      img {
        width: 100px;
      }
    }
  }

  .navRight {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    a {
      font-size: 18px;
      color: #ffffff;
      margin-left: 30px;

      &.act {
        color: #fff100;
      }
    }
  }
}

.csBanner {
  width: 1220px;
  margin: 0 auto 30px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .BannerLeft {
    width: 451px;
    height: 395px;
    //border: solid 1px #eeeeee;

    img {
      width: 451px;
      height: 395px;
      object-fit: scale-down;
    }
  }

  .Bannerright {
    display: flex;
    align-items: center;
    width: 739px;
    min-height: 392px;
    border: solid 1px #eeeeee;
    padding: 12px 17px;

    p {
      font-size: 16px;
      color: #333333;
      width: 100%;
      line-height: 28px;
      overflow: hidden;
    }

    .BannerBox {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-top: 40px;

      .bannerBtn1 {
        width: 215px;
        height: 50px;
        background-color: #c70005;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;

        img {
          margin-right: 8px;
        }
      }

      .bannerBtn2 {
        width: 215px;
        height: 50px;
        background-color: #007ac7;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;

        img {
          margin-right: 8px;
        }
      }

      .bannerBtn3 {
        width: 215px;
        height: 50px;
        background-color: #e5580b;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;

        img {
          margin-right: 8px;
        }
      }
    }
  }
}

.csXiangmu {
  width: 100%;
  padding: 80px 0;

  .xmTit {
    width: 100%;
    text-align: center;
  }

  .xmList {
    width: 100%;
    min-height: 216px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 33px;

    .xmBox {
      max-width: 383px;
      height: 280px;
      /*text-align: center;*/
      position: relative;
      overflow: hidden;
      margin-bottom: 20px;

      .img1 {
        width: 93px;
        position: absolute;
        top: -24px;
        right: -20px;
      }

      .img2 {
        width: 100%;
        height: 100%;
        vertical-align: top;
        object-fit: scale-down;
      }

      p {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        background-color: #c70005;
        line-height: 41px;
        font-size: 20px;
        color: #ffffff;
        padding: 0 10px;
        text-align: center;
      }
    }
  }
}

.csBottom {
  width: 100%;
  background: url("../assets/Template/bottomBGc_03.jpg") repeat top center;
  padding-bottom: 50px;

  .fcTit {
    width: 100%;
    text-align: center;
    padding-top: 67px;
    font-size: 32px;
    font-weight: bold;
  }
  .fc-desc {
    margin-top: 30px;
    p {
      font-size: 18px;
      text-indent: 36px;
      line-height: 32px;
    }
  }
  .imgList {
    display: block;
    margin-top: 20px;
    div {
      margin-bottom: 30px;
      img {
        display: block;
        max-width: 100%;
        margin: 0 auto 15px;
      }
      p {
        font-size: 20px;
        line-height: 36px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  .fcList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 35px;

    .listRight {
      flex: 1;
      margin-left: 30px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      align-content: center;

      .fcBox {
        width: 383px;
        height: 192px;
        margin-bottom: 20px;
        background-color: #f2f2f2;
        position: relative;

        p {
          width: 100%;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
          position: absolute;
          bottom: 0;
        }
      }

      .fcBox2 {
        width: 383px;
        height: 192px;
        background-color: #f2f2f2;
        position: relative;

        p {
          width: 100%;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }

  .csLianx {
    width: 100%;
    padding-top: 90px;

    .lianxiTit {
      width: 100%;
      text-align: center;
      padding-bottom: 50px;
    }

    .lianXLeft {
      width: 631px;
      height: 199px;
      background-color: #ffffff;

      .lianXimg {
        width: 100%;
        text-align: center;
        padding-top: 33px;

        img {
          width: 70px;
        }
      }

      .lianXtex {
        width: 100%;
        text-align: center;
        color: #666666;
        font-size: 18px;
        padding-top: 15px;
      }
    }

    .lianXRight {
      width: 551px;
      height: 199px;
      background-color: #ffffff;

      .lianXimg {
        width: 100%;
        text-align: center;
        padding-top: 33px;

        img {
          width: 70px;
        }
      }

      .lianXtex {
        width: 100%;
        text-align: center;
        color: #666666;
        font-size: 18px;
        padding-top: 15px;
      }
    }
  }
}

.csFooter {
  width: 100%;
  height: 190px;
  background-color: #333333;

  .footerLeft {
    display: flex;
    height: 190px;
    justify-content: space-between;
    align-items: center;

    img {
      margin-right: 15px;
    }
  }

  .footerCen {
    flex: 1;
    padding-top: 30px;
    padding-bottom: 30px;
    padding-right: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    height: 190px;

    p {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      /*margin-top: 15px;*/
    }
  }

  .footerRight {
    width: 100px;
    height: 190px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 100px;

    p {
      width: 100%;
      text-align: center;
      padding-top: 10px;
      font-size: 14px;
      color: #ffffff;
    }
  }
}

.xiangmFab {
  width: 186px;
  height: 52px;
  background-color: #c70005;
  border-radius: 26px 0 0 26px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  position: fixed;
  right: 0;
  top: 250px;
  cursor: pointer;

  img {
    margin-left: 30px;
    margin-right: 15px;
  }
}

.bx {
  width: 1220px;
  margin: 0 auto;
}

.bx-Box {
  width: 1220px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.more-btn {
  display: block;
  margin: 20px auto 0;
  font-size: 18px;
  background: #c70005;
  color: #fff;
}
</style>
